import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SingleReputationFragment } from '../../../../graphql/generated/graphql_offer';
import { SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import ReputationItem from './ReputationItem';

interface Props extends ClassAttributes<HTMLElement> {
  directorReputation: SingleReputationFragment | null;
  optimizerReputation: SingleReputationFragment;
  refresh: () => void;
  className?: string;
}

const ReputationDetail = ({ directorReputation, optimizerReputation, refresh, className }: Props) => (
  <Root className={className}>
    <ReputationHeading variant="h6">
      <FormattedMessage id="reputation.review" />
    </ReputationHeading>
    <OptimizerReputation reputation={optimizerReputation} refresh={refresh} />
    {directorReputation ? <DirectorReputation reputation={directorReputation} refresh={refresh} /> : null}
  </Root>
);

const Root = styled(Paper)({
  marginTop: SPACING_LARGE,
  marginBottom: SPACING_UNIT,
  padding: SPACING_REGULAR,
});

const ReputationHeading = styled(Typography)({
  marginBottom: SPACING_REGULAR,
});

const OptimizerReputation = styled(ReputationItem)({});

const DirectorReputation = styled(ReputationItem)({
  paddingLeft: SPACING_LARGE,
  marginTop: SPACING_REGULAR,
});

export default ReputationDetail;
